module.exports = __webpack_public_path__ + "static/img/realtime-nomina.18b37ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/realtime-nomina.png
// module id = fFc3
// module chunks = 1